import gsap from 'gsap';
import Swiper from 'swiper/bundle';
import idx from '../helpers/idx';

export default () => {
  let buttonsWrapper = document.querySelector('.tabs__buttons');
  let buttons = document.querySelectorAll('.tabs__button');
  let tabs = document.querySelectorAll('.tabs__wrapper>*');
  let tabsWrapper = document.querySelector('.tabs__wrapper');
  const container = document.querySelector('.swiper-tabs-container');

  if(!container) {return}

  const tabsSlider = new Swiper(container, {
    allowTouchMove: false,
  });

  const ACTIVE_BTN = 'tabs__button--active';

  if (buttons.length && tabs.length) {
    let cursor = document.querySelector('.tabs__cursor');

    buttons.forEach(function(btn, index) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        tabsSlider.slideTo(index, 300);
      
        if (!btn.classList.contains(ACTIVE_BTN)) {
          let oldBtn = document.querySelector(`.${ACTIVE_BTN}`);
          oldBtn.classList.remove(ACTIVE_BTN);
          let oldIndex = idx(oldBtn);
          let diff = index - oldIndex;
          let direction = 0;
          if (diff > 0) {
            direction = '-';
          } else {
            direction = '';
          }

          let tl = gsap.timeline({paused: true});

          tl.to(cursor, {
            skewX: `${direction}10deg`,
            duration: 0.3
          });
          tl.to(cursor, {
            xPercent: 100*index,
            duration: 0.3,
            ease: 'power2.inOut'
          }, '-=0.2');
          tl.to(cursor, {
            skewX: '0deg',
            duration: 0.3
          }, '-=0.2');

          let duration = tl.duration();

          

          

          // tabs part
          // let newTab = tabs[index];
          // let oldTab = tabs[oldIndex];

          // gsap.set(newTab, {
          //   "display": "block",
          //   "position": "absolute",
          //   "left": "0",
          //   "top": "0",
          //   xPercent: `${direction ? '' : '-'}100`,
          // });

          // gsap.set(tabsWrapper, {
          //   "height": Math.max(newTab.clientHeight, oldTab.clientHeight)+50
          // });

          // tl.to(newTab, {
          //   xPercent: 0,
          //   duration: duration,
          //   ease: 'power3.inOut'
          // }, 0);

          // tl.to(oldTab, {
          //   xPercent: `${direction}100`,
          //   duration: duration,
          //   ease: 'power3.inOut',
          //   onComplete: ()=>{
          //     gsap.set(newTab, {
          //       "display": "block",
          //       "position": "static"
          //     });
          //     gsap.set(oldTab, {
          //       "display": "none",
          //       "position": "static"
          //     });
          //     gsap.set(tabsWrapper, {
          //       "height": 'auto'
          //     });
          //   }
          // }, 0);

          tl.play();

          btn.classList.add(ACTIVE_BTN);
        }
      });
    });
  }
}